module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "widht": "100%",
      "height": "100vh"
    }
  }, [_c('br'), _c('br')]) : _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cfb6c0d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/index.vue
// module id = 2954
// module chunks = 1